import { Component, Input, signal, WritableSignal } from '@angular/core';
import { OriInput } from '~/components/ui/input'


@Component({
  selector: 'search-bar',
  standalone: true,
  imports: [OriInput],
  template: `
    <input   type="text"
      placeholder="Search all columns"
      [value]="globalFilter()"
      (input)="onInput($event)" class="focus-visible:ring-2 focus-visible:ring-blue-500 focus-visible:ring-offset-1 shadow-md" oriInput placeholder="Search in all columns..." type="search" />
  `
})

export class SearchBarComponent {
  /**
   * Expects a Writable<string> passed from the parent.
   * The parent should own the state, this component just modifies it.
   */
  @Input({ required: true}) globalFilter!: WritableSignal<string>;

  onInput(event: Event) {
    const value = (event.target as HTMLInputElement).value;
    this.globalFilter.set(value);
  }


}
